import {useNavigate} from "react-router-dom";

export const EmployerCtaSection = () => {
    const navigate = useNavigate();

    return (
        <section className="oec-cta-section">
            <div className="oec-section-inner">
                <div className="oec-cta-band">
                    <img
                        className="oec-cta-photo"
                        src="/public/sections/cta_employer.jpg"
                        alt="Employer reviewing candidates"
                        loading="lazy"
                    />

                    <div className="oec-cta-copy">
                        <span className="oec-cta-eyebrow">FOR EMPLOYERS</span>
                        <h2 className="oec-cta-title">
                            Find the Talent Behind<br/>
                            Ethiopia&apos;s Energy Future
                        </h2>
                        <p className="oec-cta-text">
                            Post jobs, search candidates, and connect with
                            skilled professionals in the energy sector.
                        </p>
                        <button className="oec-cta-btn" onClick={() => navigate("/auth/signup")}>
                            Post a Job <i className="fas fa-arrow-right"/>
                        </button>
                    </div>

                    <div className="oec-cta-aside">
                        <i className="fas fa-users oec-cta-aside-icon"/>
                        <p className="oec-cta-aside-title">Quick. Easy. Effective.</p>
                        <p className="oec-cta-aside-text">Reach the right talent, faster.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};
